import React from "react";
import { JsonLd } from "../components/common/JsonLd";
import { RelatedPages } from "../components/common/RelatedPages";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { ImagePager } from "../components/common/ImagePager";
import { PATH_PRACTICE } from "../utils/constants";
import pageContent from "../data/pages/praxis.json";
import { buildPracticePlaceGraph } from "../utils/structured-data";

export default function PracticePage() {
  const practiceImages = [
    {
      src: "/images/start_image_1.jpeg",
      alt: "Ergotherapie Rottweil - Heller Therapieraum mit moderner Therapieliege für neurologische und psychiatrische Behandlungen",
    },
    {
      src: "/images/start_image_6.jpg",
      alt: "Ergotherapie Rottweil - Gem\u00fctlicher Besprechungsraum f\u00fcr vertrauliche Beratungsgespr\u00e4che",
    },
    {
      src: "/images/start_image_3.jpeg",
      alt: "Ergotherapie Rottweil - Gro\u00dfz\u00fcgiger Therapieraum mit Sprossenwand f\u00fcr motorische \u00dcbungen",
    },
  ];

  return (
    <>
      <SEOHelmet page="praxis" pathname={PATH_PRACTICE} />
      <JsonLd data={buildPracticePlaceGraph()} />

      <main className="space-y-12 sm:space-y-24">
        <section className="overflow-hidden pt-6" aria-label="Unsere Praxis">
          <div className="mx-auto px-6 lg:px-8">
            <header className="mb-10 sm:mb-14">
              <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
                {pageContent.h1}
              </h1>
            </header>

            <div className="grid gap-6 sm:gap-8 lg:grid-cols-2">
              <div>
                {pageContent.paragraphs.map((paragraph, index) => (
                  <p
                    key={index}
                    className={`${index === 0 ? "mt-2" : "mt-4"} text-base leading-7 text-gray-500 dark:text-gray-400 lg:pr-8`}
                  >
                    {paragraph}
                  </p>
                ))}
              </div>

              <ImagePager images={practiceImages} />
            </div>
          </div>
        </section>
        <RelatedPages pathname={PATH_PRACTICE} />
      </main>
    </>
  );
}
